import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, CheckboxGroup, CheckboxLabel } from '../AdvancedSearchBuilder.styled';

const BrandsSection = ({ brands, selectedBrands, onToggle }) => {
  const { t } = useTranslation();
  if (!brands?.length) return null;
  return (
    <Section>
      <SectionTitle>{t('brand')}</SectionTitle>
      <CheckboxGroup>
        {brands.slice(0, 10).map((b) => (
          <CheckboxLabel key={b.value} checked={selectedBrands.includes(b.value)}>
            <input type="checkbox" checked={selectedBrands.includes(b.value)} onChange={() => onToggle(b.value)} />
            {b.label}
          </CheckboxLabel>
        ))}
      </CheckboxGroup>
    </Section>
  );
};

export default BrandsSection;

